import React from "react";
import { Typography, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import { CloudUpload } from "@material-ui/icons";

export default function CreateCaseStudyModal({
    newCaseStudy,
    setNewCaseStudy,
    createModal,
    handleCreateModalClose,
    handleCreateCaseStudy,
}) {

    // setCurrentDialog("Create Lab");
    const [currentDialog, setCurrentDialog] = React.useState("Create Case Study");
    const [loading, setLoading] = React.useState({ loading: false, message: "" })

    const renderDialogContent = () => {
        switch (currentDialog) {
            case "Create Case Study":
                return (
                    <div>
                        <Typography
                            variant="h5"
                            style={{
                                marginBottom: "10px",
                            }}
                        >
                            Enter the Case Study details:
                        </Typography>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Case Study Name"
                            type="text"
                            fullWidth
                            required
                            value={newCaseStudy.name}
                            onChange={(event) => setNewCaseStudy({ ...newCaseStudy, name: event.target.value })}
                        />
                        <TextField
                            margin="dense"
                            id="brief"
                            label="Brief Description"
                            type="text"
                            fullWidth
                            multiline
                            required
                            rows={3}
                            value={newCaseStudy.description}
                            onChange={(event) => setNewCaseStudy({ ...newCaseStudy, description: event.target.value })}
                        />
                        {/* Icon Image Upload */}
                        {/* <Button
                            variant="contained"
                            component="label"
                            color="info"
                            style={{ marginTop: "20px" }}
                        >
                            <CloudUpload /> &nbsp; Upload Image
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                required
                                onChange={handleIconUpload}
                            />
                        </Button>
                        {iconImage && (
                            <div style={{ marginTop: "10px" }}>
                                <strong>Uploaded Image:</strong> {iconImage.name}
                            </div>
                        )}
                        <Typography
                            variant="caption"
                            style={{ display: "block", marginTop: "5px" }}
                        >
                            A 16:9 aspect ratio image is recommended
                        </Typography> */}
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <div>
            <Dialog
                open={createModal}
                onClose={handleCreateModalClose}
                aria-labelledby="form-dialog-title"
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="form-dialog-title">
                    <div style={{ fontSize: "30px" }}>Create Case Study</div>
                </DialogTitle>
                <DialogContent>{renderDialogContent()}</DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleCreateModalClose}
                        color="quCreateColor"
                        disabled={loading.loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleCreateCaseStudy}
                        disabled={loading.loading}
                        color="quCreateColor"
                    >
                        {currentDialog === "Create Case Study" ? "Submit" : "Next"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );

}
